// liked content like (save/bookmark) actions
export const CREATE_LIKED_CONTENT_ERROR = 'CREATE_LIKED_CONTENT_ERROR';
export const CREATE_LIKED_CONTENT_REQUEST = 'CREATE_LIKED_CONTENT_REQUEST';
export const CREATE_LIKED_CONTENT_SUCCESS = 'CREATE_LIKED_CONTENT_SUCCESS';

export const DELETE_LIKED_CONTENT_ERROR = 'DELETE_LIKED_CONTENT_ERROR';
export const DELETE_LIKED_CONTENT_REQUEST = 'DELETE_LIKED_CONTENT_REQUEST';
export const DELETE_LIKED_CONTENT_SUCCESS = 'DELETE_LIKED_CONTENT_SUCCESS';

export const GET_LIKED_CONTENT_ERROR = 'GET_LIKED_CONTENT_ERROR';
export const GET_LIKED_CONTENT_REQUEST = 'GET_LIKED_CONTENT_REQUEST';
export const GET_LIKED_CONTENT_SUCCESS = 'GET_LIKED_CONTENT_SUCCESS';
